module.exports = "::ng-deep .header-bar .search-wrapper{max-width:245px}"